import 'vue/jsx'

// 引入windi css
import '@/plugins/unocss'

// 导入全局的svg图标
import '@/plugins/svgIcon'
import SvgIcon from 'vue-svgicon'

// 初始化多语言
import { setupI18n } from '@/plugins/vueI18n'

// 引入状态管理
import { setupStore } from '@/store'

// 全局组件
import { setupGlobCom } from '@/components'

// 引入element-plus
import { setupElementPlus } from '@/plugins/elementPlus'

// 引入全局样式
import '@/styles/index.less'

// 引入动画
import '@/plugins/animate.css'

// 引入 UnoCSS
import 'virtual:uno.css'

// 路由
import { setupRouter } from './router'

// 权限
import { setupPermission } from './directives'

import { createApp, defineAsyncComponent } from 'vue'
import { Icon } from '@iconify/vue'

import App from './App.vue'

import './permission'

// ✅ 富文本编辑器改为异步全局组件
// 说明：
// 1. 仍然注册为全局组件 Editor，不影响原有页面里的 <Editor /> 使用
// 2. 不再让登录页、首屏页面一开始就加载 wangEditor 大包
// 3. 只有真正渲染 <Editor /> 的页面，才会加载富文本组件
const AsyncEditor = defineAsyncComponent({
  loader: () => import('./components/Editor/src/Editor.vue'),
  suspensible: false
})

// 创建实例
const setupAll = async () => {
  const app = createApp(App)

  await setupI18n(app)

  setupStore(app)

  setupGlobCom(app)

  setupElementPlus(app)

  setupRouter(app)

  setupPermission(app)

  app.component('Icon', Icon)

  // 注册全局组件
  app.component('svg-icon', SvgIcon)

  // ✅ 保留原来的全局组件名称，避免影响业务页面
  app.component('Editor', AsyncEditor)

  app.mount('#app')
}

setupAll()
